export const SIZE_PACKS = {
    UPLOAD_TEMPLATE_BUTTON: "upload-template-button",
    FILES_INPUT: "files-input",
    STATUS_MESSAGE: "status-message",
    PROCESSING_NTFN: "processing-notification",
    PACK_NAME_SPECIFICATION: "pack-name-specification",
    PACK_ID_SPECIFICATION: "pack-id-specification",
    CREATE_SIZE_PACK_SPECIFICATION: "create-size-pack-specification",
    UPDATE_SIZE_PACK_SPECIFICATION: "update-size-pack-specification",
    PACK_ARCHIVED_SPECIFICATION: "pack-archived-specification",
    PACK_SIZE_COLUMNS_SPECIFICATION: "pack-size-columns-specification",
    PACK_QTY_SPECIFICATION: "pack-qty-specification",
    BLANK_TEMPLATE_BUTTON: "blank-template-button",
    DOWNLOAD_TEMPLATE_BUTTON: "download-template-button",
    FILE_SPECIFICATION: "file-specification",
    DOWNLOAD_BUTTON_MENU: "download-button-menu",
    SIZE_PACK_TABLE: "size-pack-table",
};
